import { Action } from "@opstel/query/v2/models/action";
import { actionSchema } from "@opstel/query/models/action";
import { z } from "zod/v3";
import { ZodOutputFor } from "@opstel/query/zod-utils";
import { EpdResponse } from "@opstel/gen/knop/ui/v1/api/epd_pb";
import { PlainMessage } from "@bufbuild/protobuf";
import { Location, locationSchema } from "@opstel/query/models/location";
import { ShuntingUnit, shuntingUnitSchema } from "@opstel/query/models/shuntingUnit";

export interface EPDData {
  location: Location;
  actions: Action[];
  shuntingUnitsById: Record<string, ShuntingUnit>;
}

const epdDataSchema = z.object({
  location: locationSchema,
  actions: z.array(actionSchema),
  shuntingUnitsById: z.record(z.string(), shuntingUnitSchema),
}) satisfies ZodOutputFor<EPDData>;

export function parseEpdData(proto: PlainMessage<EpdResponse>): EPDData {
  return epdDataSchema.parse(proto);
}
